import { ReferralWithScope_UserWithoutId } from './DataStructures';

const ARCHIVE_ELIGIBLE_STATUSES = new Set<string>(['failed', 'alreadyaCustomer']);
const ONE_WEEK_IN_MILLISECONDS = 7 * 24 * 60 * 60 * 1000;
const CREATED_SENT_STALE_MILLISECONDS = 14 * 24 * 60 * 60 * 1000;

const getReferralReferenceDate = (referral: ReferralWithScope_UserWithoutId): string | null => {
  return referral.conversation.lastMessageAt ?? referral.created;
};

export const isArchivedInDashboardPreview = (referral: ReferralWithScope_UserWithoutId, now: Date = new Date()): boolean => {
  if (!ARCHIVE_ELIGIBLE_STATUSES.has(referral.status)) {
    return false;
  }

  const referenceDateString = getReferralReferenceDate(referral);
  if (!referenceDateString) {
    return false;
  }

  const referenceDate = new Date(referenceDateString);
  if (Number.isNaN(referenceDate.getTime())) {
    return false;
  }

  return now.getTime() - referenceDate.getTime() > ONE_WEEK_IN_MILLISECONDS;
};

export const isStaleCreatedSentReferralInDashboardPreview = (
  referral: ReferralWithScope_UserWithoutId,
  now: Date = new Date()
): boolean => {
  if (referral.status !== 'created' || referral.conversation.viewerHasUnread) {
    return false;
  }

  const lastMessageAt = referral.conversation.lastMessageAt;
  if (!lastMessageAt) {
    return false;
  }

  const lastMessageDate = new Date(lastMessageAt);
  if (Number.isNaN(lastMessageDate.getTime())) {
    return false;
  }

  return now.getTime() - lastMessageDate.getTime() > CREATED_SENT_STALE_MILLISECONDS;
};
